import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserManager } from '../interfaces/admin/UserManager';
import { UserNormal } from '../interfaces/manager/UserNormal';
import { tap, catchError } from 'rxjs/operators';
import { MessageService } from './message.service';
import { ChangePassword } from '../interfaces/manager/ChangePassword';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private serverApi = environment.serverApi + 'auth/';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,     private messageService: MessageService,
    ) { }

  login(credentials): Observable<any> {
    return this.http.post(this.serverApi + 'signin', {
      username: credentials.username,
      password: credentials.password
    }, httpOptions);
  }

  register(user): Observable<any> {
    return this.http.post(this.serverApi + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    }, httpOptions);
  }

  saveManagerUser(userManager: UserManager): Observable<UserManager> {
    return this.http.post<UserManager>(this.serverApi + 'add/manager', userManager).pipe(
      tap((newManager) => this.log(`added manager w/ id=${newManager}`)),
      catchError(this.handleError<any>('addManager'))
    );
  }

  saveNormalUser(userNormal: UserNormal): Observable<UserNormal> {
    return this.http.post<UserNormal>(this.serverApi + 'add/user', userNormal, this.httpOptions).pipe(
      tap((user: UserNormal) => this.log(`added user w/ id=${user.userToSave.id}`)),
      catchError(this.handleError<UserNormal>('addUser'))
    );
  }


  updateNormalUser(userNormal: UserNormal): Observable<UserNormal> {
    return this.http.put<UserNormal>(this.serverApi + 'update/user', userNormal, this.httpOptions).pipe(
      tap((user: UserNormal) => this.log(`updated user w/ id=${user.userToSave.id}`)),
      catchError(this.handleError<UserNormal>('updateUser'))
    )}

  changePassword(changePassword: ChangePassword): Observable<ChangePassword> {
    return this.http.post<ChangePassword>(this.serverApi + 'change/password', changePassword, this.httpOptions).pipe(
      tap(() => this.log(`password changed`)),
      catchError(this.handleError<ChangePassword>('changePassword'))
    );
  }

/**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a ToolService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`ToolService: ${message}`);
  }
}
